/* eslint-disable */
import React, { useCallback, useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Tabs, Button, Modal, message, Avatar, Table, Tag, Breadcrumb, Divider } from 'antd'
import * as actions from '@/models/notifies/actions';
import * as selectors from '@/models/notifies/selectors'
import * as services from '@/models/notifies/services'
import styles from './notifies.module.scss'

function getColumns({ fetch }) {
  const dispatch = useDispatch()
  const deleteManager = item => {
    services.deleteSpitem(item._id).then(res => {
      fetch()
    }).catch((err) => {
      message.error(err?.message || '删除失败，请刷新重试');
    }).finally(() => { });

  }
  return [
    {
      key: '_id',
      title: '编号',
      width: 60,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    {
      title: '操作类型',
      render: item => (
        <div>
          <div>理赔通知</div>
        </div>
      )
    },
    {
      title: '师傅姓名',
      render: item => (
        <div>
          <div>{item?.worker?.realname}</div>
        </div>
      )
    },
    {
      title: '相关工单',
      render: item => (
        <div>
          <div>{item?.order?.order_no}</div>
        </div>
      )
    },
    {
      title: '当前保证金余额',
      render: item => (
        <div>
          <div>{item.cur_baozheng}</div>
        </div>
      )
    },
    {
      title: '扣款金额',
      render: item => (
        <div>
          <div>{item.sp_amount}</div>
        </div>
      )
    },
    {
      title: '扣款事由',
      render: item => (
        <div>
          <div>{item.sp_reason}</div>
        </div>
      )
    },
    {
      title: '通知时间',
      render: item => (
        <div>
          {item.response_time ? dayjs(item.response_time).fromNow() : '-'}
        </div>
      )
    },

    {
      title: '操作',
      render: item => {
        return (
          <div>
            <a onClick={() => { deleteManager(item) }}>删除</a>
          </div>
        )
      }
    }
  ]
}

function OperationNotifie(props, ref) {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [mgroups, setMgroups] = useState([]);

  useImperativeHandle(ref, () => ({
    add() {
      showInfoDialog('添加分组')
    },
  }));

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }
  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setLoading(true)
    services.fetchSpList(params).then(res => {
      setMgroups(res.data || [])
      setTotal(res.total || 0)
    }).catch((err) => {
      message.error(err?.message || '获取列表失败，请刷新重试');
    }).finally(() => { setLoading(false) });
  }, [])


  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetch(nextQuery)
  })

  const columns = getColumns({ fetch })

  useMount(() => {
    fetch()
  })

  return (
    <div className={styles.container}>
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={mgroups}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>

    </div>
  )
}

export default forwardRef(OperationNotifie)
